import { ApiEnvironment } from '../../models/api-environment';

export class SmsNotificationServiceEnvironment extends ApiEnvironment {
  get smsNotificationSendUrl() {
    return `${this.baseUrl}/api/smsnotification/send`;
  }

  get smsNotificationStatusDetailsUrl() {
    return `${this.baseUrl}/api/smsnotification/statusdetails`;
  }

  get qrCodeUrl() {
    return `${this.baseUrl}/api/qrCode`;
  }

  override resolve(environment: unknown) {
    return environment instanceof SmsNotificationServiceEnvironment
      ? environment
      : this;
  }
}

export const smsNotificationServiceEnvironment =
  new SmsNotificationServiceEnvironment();
